module.exports = __webpack_public_path__ + "img/hnc.fc0e2346.jpg";